
export default class CollegeReportModel {
  constructor(data) {
    if (!data) {
      data = {};
    }

    this.num_students_registered = data.num_students_registered || 0;
    this.num_students_who_have_scheduled_a_session = data.num_students_who_have_scheduled_a_session || 0;
    this.num_counselors_registered = data.num_counselors_registered || 0;
    this.num_individual_sessions_scheduled = data.num_individual_sessions_scheduled || 0;
    this.num_group_sessions_scheduled = data.num_group_sessions_scheduled || 0;
    this.num_college_events_scheduled = data.num_college_events_scheduled || 0;
    this.num_students_with_sessions = data.num_students_with_sessions || 0;
    this.avg_sessions_per_student = data.avg_sessions_per_student || 0;

    this.appointment_report = data.appointment_report || []; // month_reports: [{month, year, number_of_appointments }]
    this.registrations_report = data.registrations_report || []; // month_reports: [{month, year, number_of_appointments }]

    this.initial_individual_session_credits = data.initial_individual_session_credits || 0;
    this.current_individual_session_credits = data.current_individual_session_credits || 0;
    this.initial_group_session_credits = data.initial_group_session_credits || 0;
    this.current_group_session_credits = data.current_group_session_credits || 0;

    this.num_off_campus_counselors_registered = data.num_off_campus_counselors_registered || 0;
    this.num_on_campus_counselors_registered = data.num_on_campus_counselors_registered || 0;
    this.num_colleges_with_students_registered = data.num_colleges_with_students_registered || 0;

    this.free_individual_credit_uses_per_student = data.free_individual_credit_uses_per_student;
    this.free_group_credit_uses_per_student = data.free_group_credit_uses_per_student;
    this.individual_credits_remaining = data.individual_credits_remaining;
    this.group_credits_remaining = data.group_credits_remaining;

    this.individual_credits_used = data.individual_credits_used || 0;
    this.individual_credits_budgeted = data.individual_credits_budgeted || 0;

    this.group_credits_used = data.group_credits_used || 0;
    this.group_credits_budgeted = data.group_credits_budgeted || 0;

    this.demographics = data.demographics || {
        total_students: 0,
        gender_male: 0,
        gender_female: 0,
        gender_transgender_female: 0,
        gender_transgender_male: 0,
        gender_non_binary: 0,
        gender_unknown: 0,
        gender_prefer_not_to_say: 0,
        gender_other: 0,
        gender_na: 0,
        race_white: 0,
        race_black: 0,
        race_native: 0,
        race_asian: 0,
        race_pacific: 0,
        race_other: 0,
        student_athlete: 0,
        international_student: 0,
        live_on_campus: 0,
        student_status_part_time: 0,
        student_status_full_time: 0,
    };
    this.survey_results = data.survey_results || null; // {total_survey_responses, question_breakdowns: [{question_text, answer_breakdowns: [{answer_text, number_of_responses}]}] }

    this.individual_credit_burndown_date = data.individual_credit_burndown_report || null;
  }
}
